import { useMutation } from "react-query";
import { printCode } from "@/api/Inventories/Print/print-codes-query";
import { refreshCode } from "@/api/Inventories/Inventory/inventory-query";

export function useRefreshInventory() {
	return useMutation(refreshCode, {
		onSuccess: (_response) => {},
	});
}

export function usePrintCodes() {
	return useMutation(printCode, {
		onSuccess: (_response) => {},
	});
}
